import { createContext } from 'react';

export interface StickyTabTheme {
  background?: string;
  selected?: string;
  default?: string;
}

export const StickyTabThemeContext = createContext<StickyTabTheme>({});
